import { render, staticRenderFns } from "./formProperties.vue?vue&type=template&id=20a2cb28&scoped=true&"
import script from "./formProperties.vue?vue&type=script&lang=js&"
export * from "./formProperties.vue?vue&type=script&lang=js&"
import style0 from "./formProperties.vue?vue&type=style&index=0&id=20a2cb28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2cb28",
  null
  
)

export default component.exports